<template>
    <div>
        <b-breadcrumb :items="items"></b-breadcrumb>
        <div class="col-12">
            <nav class="navbar navbar-expand-lg navbar-light">
                <span v-if="employee"><b>คุณ {{employee.employee_no}} {{employee.name}} แผนก {{employee.occupation && employee.occupation.department ? employee.occupation.department.department_name : "-"}}</b></span>
                <div class="ml-auto">
                    <form class="form-inline my-2 my-lg-0">
                        <date-picker
                            v-model="search.date"
                            :format="changeFormat"
                            :lang="lang"
                            confirm
                            placeholder="วันที่เริ่มต้น">
                        </date-picker>&nbsp;
                        <b-form-select v-model="search.leave_type" :options="optionLeaveDay">
                        </b-form-select>&nbsp;
                        <button class="btn btn-success"
                                type="button">
                            <icon name="search"></icon>
                            ค้นหา
                        </button>&nbsp;
                        <button class="btn btn-warning"
                                @click="addWorkSchedule"
                                type="button">
                            <icon name="plus"></icon>
                            สร้างวันลา
                        </button>&nbsp;
                    </form>
                </div>
            </nav>
        </div>
        <span>*จำนวน ชม.การลา(ที่อนุมัติแล้ว) จะมีการบวกเพิ่มให้ 1ชม.(ไว้ใช้สำหรับการคำนวนเงินเดือน)</span><br>
        <span>*จำนวน ชม.การลา(ที่อนุมัติแล้ว) ที่แท้จริงจะต้องหักออก 1ชม.</span>
        <div class="container-fluid" style="background-color: white">
            <div class="col-sm-12 table-responsive">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">ประเภทการลา</th>
                        <th scope="col">วันที่</th>
                        <th scope="col">ถึง</th>
                        <th scope="col">ชม.การลา</th>
                        <th scope="col">สถานะ</th>
                        <th scope="col">แก้ไข</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in work_schedule" v-if="work_schedule.length > 0">
                        <td>
                            <template v-if="data.leave_day">
                                {{data.leave_day.name}}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>{{data.start_date | moment('DD/MM/YYYY')}}</td>
                        <td>{{data.end_date | moment('DD/MM/YYYY')}}</td>
                        <td>
                            {{data.hour}}
                        </td>
                        <td>
                            <template v-if="data.status==1">
                                <span style="color: green;">อนุมัติ</span>
                            </template>
                            <template v-else-if="data.status==0">
                                <span style="color: red">ปฏิเสธ</span>
                            </template>
                            <template v-else>รอการอนุมัติ</template>
                        </td>
                        <td>
                            <a @click="showWorkSchedule(data.id)" v-if="data.status!=1">
                                <icon name="pencil-alt"></icon>
                            </a>
                            &nbsp&nbsp
                            <a @click="showDeleteModal(data.id)">
                                <icon name="trash"></icon>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br>
                <div v-if="work_schedule.length > 0">
                    <vue-pagination :pagination="dataPaginate"
                                    @paginate="getWorkScheduleList">
                    </vue-pagination>
                </div>
            </div>
            <!--b-modal-->
            <b-modal hide-footer hide-header ref="add_work_schedule">
                <work-schedule-modal @submit="saveWorkSchedule">
                </work-schedule-modal>
            </b-modal>
            <!--delete-->
            <b-modal hide-header hide-footer ref="delete_item">
                <div style="text-align: center;">
                    <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                    <br />
                    <button type="button"
                            @click="deleteWorkSchedule"
                            class="btn btn-success">
                        ตกลง
                    </button>
                    &nbsp&nbsp
                    <button type="button"
                            @click="hideDeleteModal"
                            class="btn btn-secondary">
                        ยกเลิก
                    </button>
                </div>
            </b-modal>
            <!--<pre class="alert alert-primary">{{form}}</pre>-->
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import WorkScheduleModal from "./WorkScheduleModal";
import DatePicker from 'vue2-datepicker'
import {canViewSuperAdmin} from "../../../../util/Permissions"
import moment from "moment";
import VuePagination from "../../../Pagination";

export default {
        components: {VuePagination, WorkScheduleModal,DatePicker},
        name: "work-schedule-form",
        props: {
            id : { default: null }
        },
        created(){
            this.$store.dispatch("Employee/getEmployeeDataAll").then(employee=>{
                this.employee_all = employee;
            });
            this.$store.dispatch("LeaveDay/setLeaveDayAll");
        },
        data(){
          return{
              employee_all : [],
              search : {
                date : '',
                leave_type : null,
              },
              items: [
                  {
                      text: 'ตารางเวลา',
                      to : {name : "work-schedules"}
                  },
                  {
                      text: 'เพิ่มเติม',
                      active: true
                  }
              ],
              delete_id : "",
              changeFormat: {
                  stringify: (date) => {
                      if(date && moment(date).format('MM') == '02' && moment(date).format('DD') == '29')
                          return '29/02/' + moment(date).add(543, 'y').format('YYYY');
                      return date ? moment(date).add(543, 'y').format('DD/MM/YYYY') : null
                  },
                  parse: (value) => {
                      return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                  }
              },
              lang: {
                  days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                  months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                  pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                  placeholder: {
                      date: 'วว/ดด/ปปปป',
                  }
              },
          }
        },
        computed:{
            canViewSuperAdmin,
            ...mapState({
                work_schedule:state=>{
                   return state.WorkScheduleEmployee.work_schedule_employee
                },
                form:state=>{
                    return state.WorkScheduleEmployee.work_schedule
                },
                employee : state=>{
                  return state.Employee.employeeForm;
                },
                optionLeaveDay:state=>{
                    return [
                        {
                            value:null,
                            text:"ค้นหาวันลา"
                        },
                        ...state.LeaveDay.leaveDayAll.map(data=>({
                            text:  data.name,
                            value: data.id
                        })),
                    ];
                },
                dataPaginate:state=>{
                    return state.WorkScheduleEmployee.dataPaginate;
                }
            })
        },
        methods:{
            showWorkScheduleModal(){
                this.$refs.add_work_schedule.show();
            },
            hideWorkScheduleModal(){
                this.$refs.add_work_schedule.hide();
            },
            showDeleteModal(id){
                this.delete_id = id;
                this.$refs.delete_item.show();
            },
            hideDeleteModal(){
                this.$refs.delete_item.hide();
            },
            saveWorkSchedule(submitValue){
                if(submitValue){
                    this.$store.dispatch("WorkScheduleEmployee/saveWorkSchedule",{
                        id : submitValue.id,
                        data : this.form
                    }).then(()=>{
                        let employee_id = this.employee ? this.employee.id : '';
                        if(employee_id){
                            this.$store.dispatch("WorkScheduleEmployee/showWorkScheduleByEmployee",employee_id).then(()=>{
                                alert("บันทึกวันลาพนักงานสำเร็จ");
                            })
                        }else{
                            alert('ไม่สามารถบันทึกการลาของพนักงานได้');
                        }
                    }).catch(err=>{
                        alert('บันทึกวันลาไม่สำเร็จ')
                    });
                }
                this.hideWorkScheduleModal();
            },
            getWorkScheduleList(){
                let employee_id = this.employee ? this.employee.id : '';
                let page = this.dataPaginate.current_page;
                this.$store.dispatch("WorkScheduleEmployee/showWorkScheduleByEmployee", {employee_id,page})
            },
            showWorkSchedule(id){
              this.$store.dispatch("WorkScheduleEmployee/showWorkScheduleById",id).then(()=>{
                  this.employee_all.forEach(data=>{
                      if(data.id === this.form.employee){
                          this.form.employee = data
                      }
                  });
                  this.showWorkScheduleModal();
              });
            },
            addWorkSchedule(){
                this.showWorkScheduleModal();
                this.$store.dispatch("WorkScheduleEmployee/clearData",this.employee);
            },
            goToWorkSchedulelist(){
                this.$store.dispatch("WorkScheduleEmployee/setWorkScheduleList").then(()=>{
                    this.$router.push({
                        name : "work-schedules"
                    })
                });
            },
            deleteWorkSchedule(){
                let employee_id = this.employee ? this.employee.id : '';
                this.$store.dispatch("WorkScheduleEmployee/delete",this.delete_id).then(()=>{
                    this.$store.dispatch("WorkScheduleEmployee/showWorkScheduleByEmployee",employee_id)
                    this.hideDeleteModal();
                });
            }
        }
    }
</script>

<style scoped>
    thead{
        background-color: white;
        color: black;
    }
    tbody{
        background-color: white;
        color: black;
    }
</style>
